import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, HelmetWrapper, Label, SkipNavContent, TYPES } from 'sarsaparilla';
import { CurrentUserProps } from '../../props/currentUser';
import { getCurrentUser } from '../../reducers/currentUser';
import { addAlert } from '../../actions/alerts';
import { login } from '../../actions/currentUser';
import AlertsContainer from '../AlertsContainer';

import styles from './LoginPage.scss';

const propTypes = {
  history: TYPES.HISTORY,
  currentUser: CurrentUserProps.isRequired,
  addAlert: PropTypes.func.isRequired,
  login: PropTypes.func.isRequired
};

export class LoginPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: ''
    };

    this.setEmail = this.setEmail.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.goLogin = this.goLogin.bind(this);
  }

  setEmail(event) {
    const { value } = event.target;

    this.setState((prevState) => ({ ...prevState, username: value }));
  }

  setPassword(event) {
    const { value } = event.target;

    this.setState((prevState) => ({ ...prevState, password: value }));
  }

  goLogin() {
    this.props.login(this.state)
      .then(() => this.props.history.push('/'))
      .catch((e) => {
        if (e.message === 'mfa') {
          this.props.addAlert({
            level: 'warning',
            title: 'Unrecognized Device',
            message: 'We don\'t recognize the device you\'re trying to login from. Please check your email to verify your identity and authorize this device.'
          });
          return;
        }

        this.props.addAlert({
          title: 'Login Trouble',
          message: 'Could not log you in. Check your email and password or try again later.'
        });
      });
  }

  render() {
    const signUpUrl = `${process.env.SITE_ROOT}/sign-up`;
    const forgotUrl = `${process.env.SITE_ROOT}/reset-password`;

    return (
      <SkipNavContent>
        <HelmetWrapper title="RIDB Login" />
        <main role="main">
          <div className={styles['login-page']}>
            <div className={styles['alerts-box']}>
              <AlertsContainer />
            </div>
            <div className={styles['modal-box']}>
              <h1>Sign In</h1>
              <p>
                <strong>Use your Recreation.gov account email to Sign In.</strong>
              </p>
              <p>
                If you do not already have an account, visit <a href={signUpUrl}>Recreation.gov</a> to sign up for one.
              </p>
              <form>
                <Label htmlFor="login-email">
                  <strong><a href={signUpUrl}>Recreation.gov</a> Email</strong>
                </Label>
                <input id="login-email" type="text" onChange={this.setEmail} />
                <Label htmlFor="login-password">
                  <strong>Password</strong>
                </Label>
                <input id="login-password" type="password" onChange={this.setPassword} />
                <p>
                  <a href={forgotUrl}>Forgot Password?</a>
                </p>
                <p>
                  <Button onClick={this.goLogin}>Sign In</Button>
                </p>
              </form>
            </div>
          </div>
        </main>
      </SkipNavContent>
    );
  }
}

LoginPage.propTypes = propTypes;

const mapStateToProps = (state) => ({
  currentUser: getCurrentUser(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ addAlert, login }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
